export default {"src":"/_next/static/media/deactiveuser.71f3e670.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};